import HomePage from './pages/homepage/homepage';

function App() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default App;
